import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router'

import { useDefaultLayoutProps } from '../../layouts/DefaultLayout/useProps'
import { actions, selectors } from '../../redux'
import { routesPath } from '../../router'

import { HomeTemplateProps } from './index'

export const useHomeTemplateProps = (): HomeTemplateProps => {
  const { t } = useTranslation()
  const layoutProps = useDefaultLayoutProps()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const locale = useSelector(selectors.app.currentLocale)
  const currentEvent = useSelector(selectors.app.getCurrentEvent)

  useEffect(() => {
    dispatch(
      actions.app.getCurrentEventRequest({
        locale: locale!,
      })
    )
  }, [dispatch, locale])

  const isEventClosed = useMemo(() => {
    if (!currentEvent.data?.registration_closing_at) return false

    const now = new Date()
    const closingDate = new Date(currentEvent.data.registration_closing_at)
    return now > closingDate
  }, [currentEvent.data])

  useEffect(() => {
    if (!currentEvent.pending && currentEvent.data?.slug && !isEventClosed) {
      navigate(generatePath(routesPath.root, { locale, slug: currentEvent.data.slug }))
    }
  }, [currentEvent, locale, navigate, isEventClosed])

  return useMemo(
    () => ({
      layout: layoutProps,
      titleDescription: {
        title: currentEvent.pending
          ? t('home.title.loading')
          : isEventClosed || !currentEvent.data
          ? t('home.title.error')
          : t('home.title.loading'),
      },
      loading: currentEvent.pending,
    }),
    [layoutProps, t, currentEvent, isEventClosed]
  )
}
